<div class="form-field" [formGroup]="group" class="slider-container" [ngStyle]="field.containerStyles">
  <mat-label *ngIf="field.label" [ngStyle]="field.labelStyles" [innerHTML]="field.label | gioNoSanitize"></mat-label>
  <mat-slider [gioEnableControl]="isEnabledFn(field.name, field.id)" [ngStyle]="field.sliderStyles"
    [required]="field.required" [formControlName]="field.name" [color]="field.color" [invert]="field.invert"
    [max]="field.max" [min]="field.min" [step]="field.step" [thumbLabel]="field.thumbLabel"
    [tickInterval]="field.tickInterval" [vertical]="field.vertical">
  </mat-slider>

</div>
